import { create } from 'zustand';
import storage from '../utils/storage';
import { STORAGE_KEYS, LOTTERY_TYPES } from '../utils/constants';

interface LotteryState {
  // 状态
  currentType: number;
  
  // 操作
  setLotteryType: (type: number) => Promise<void>;
  loadLotteryType: () => Promise<void>;
}

/**
 * 彩票类型状态管理
 */
export const useLotteryStore = create<LotteryState>((set) => ({
  // 初始状态：默认澳彩
  currentType: LOTTERY_TYPES.AO_CAI,

  // 设置彩票类型
  setLotteryType: async (type: number) => {
    await storage.setItem(STORAGE_KEYS.LOTTERY_TYPE, type);
    set({ currentType: type });
  },

  // 加载彩票类型（应用启动时调用）
  loadLotteryType: async () => {
    const type = await storage.getItem<number>(STORAGE_KEYS.LOTTERY_TYPE);
    if (type) {
      set({ currentType: type });
    }
  },
}));
